export default __webpack_public_path__ + "static/media/2020_Properties_Assets-Amenities-txt.3a19d292.svg";